import { State } from './types';

const mutations = {
  setSeriesDrawerOpen(state: State, value: boolean) {
    state.editSeriesDrawerOpen = value;
  },
  setIsUpdatingSeries(state: State, isUpdatingSeries: boolean) {
    state.isUpdatingSeries = isUpdatingSeries;
  }
};

export default mutations;
